/* global angular _ swal */
import './style.less';
import { levels } from '@prolaera/library';
import { find } from 'lodash';

export default function(
  $log,
  $rootScope,
  $scope,
  $q,
  $state,
  $location,
  $anchorScroll,
  $stateParams,
  $window,
  $timeout
) {
  'ngInject';
  const vm = this;
  vm.$onInit = activate;

  // Saves when users leaves edit course view
  // vm.$on('$destroy', () => {
  //   if (vm.reviewOnly || vm.infoForm.$pristine) return;
  //   vm.updateInfo('navSave');
  //   swal('Saving', 'Course updated', 'success');
  // });

  vm.profile_uid = $stateParams.id;

  vm.audience = {};
  vm.formData = {};
  vm.resultsQueried = false;
  vm.reviewOnly = false;

  // View dependencies
  vm.levels = levels;

  vm.changeSponsor = (sponsor_id, sponsors) => {
    const sponsor = find(sponsors, { sponsor_id });
    vm.formData.sponsor = sponsor;
  };

  vm.uploadedProductImage = link => {
    vm.formData.productImageUrl = link;
  };

  function activate() {
    $log.log('Activating update course info view');

    vm.loaded = false;
    vm.error = {};

    try {
      vm.categories = vm.categoryData.arr;
      vm.categoryDict = vm.categoryData.obj;
      vm.delivery_methods = vm.deliveryMethodData;
      vm.ngModel.form_id = vm.ngModel.form_id || 'NASBA_Live';

      if (vm.ngModel && vm.ngModel.sponsor) vm.ngModel.sponsor_id = vm.ngModel.sponsor.sponsor_id;

      const deliveryMethodIndex = _.findIndex(
        vm.deliveryMethodData,
        method => method.delivery_uid === vm.ngModel.delivery_method
      );

      // Disable summernote text areas
      if ($state.current.name === 'app.author.courses.course.edit' && vm.ngModel.adminReview) {
        $timeout(() => angular.element('.note-editable').attr('contenteditable', false), 0);
        vm.reviewOnly = true;
      }

      vm.ngModel.delivery_method = vm.deliveryMethodData[deliveryMethodIndex];
      if (!vm.ngModel.instructors) vm.ngModel.instructors = [];
      vm.formData = vm.ngModel;

      vm.states = [];
      vm.modifiedStates = [];

      for (let i = 0; i < vm.regulators.arrCurrent.length; i++) {
        const state = {
          name: vm.regulators.arrCurrent[i].name,
          state: vm.regulators.arrCurrent[i].state,
          reg_id: vm.regulators.arrCurrent[i].reg_id
        };

        if (vm.formData.hours_basic && vm.formData.hours_basic[vm.regulators.arrCurrent[i].reg_id]) {
          state.hours = vm.formData.hours_basic[vm.regulators.arrCurrent[i].reg_id];
          vm.modifiedStates.push(state);
        } else if (
          vm.regulators.arrCurrent[i].company_id !== undefined ||
          vm.regulators.arrCurrent[i].company_id === vm.profile.company_id
        ) {
          state.hours = Object.keys(angular.copy(vm.regulators.arrCurrent[i].cycle_template)).map(key => {
            return {
              category: key,
              credits: 0
            };
          });
          vm.states.push(state);
        }
      }

      if (vm.formData.vendor_id === undefined && vm.vendors[0]) {
        vm.formData.vendor_id = vm.vendors.length > 1 ? undefined : vm.vendors[0].vendor_id;
      }
      if (vm.formData.payee === undefined && vm.payees[0]) {
        vm.formData.payee = vm.payees.length > 1 ? undefined : vm.payees[0].payee_uid;
      }

      vm.reviewForms = vm.adminReviews.obj;

      if (!vm.ngModel.hours) {
        vm.formData.hours = [{}];
      }

      typeof vm.ngModel.approval === 'string'
        ? (vm.formData.approval = {
            IRS: vm.ngModel.approval
          })
        : vm.formData.approval;

      if (_.isArray(vm.ngModel.audience) && vm.ngModel.audience.length !== 0) {
        vm.ngModel.audience.forEach(aud => {
          vm.audience[aud] = true;
        });
      }

      vm.loaded = true;
    } catch (error) {
      $log.error(error);
      vm.loaded = true;
      vm.error = { status: true, refresh: activate };
      throw error;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/author/info/controller.js